import { render, staticRenderFns } from "./ContractsAddendumsRecord.vue?vue&type=template&id=2acbb019&scoped=true"
import script from "./ContractsAddendumsRecord.vue?vue&type=script&lang=js"
export * from "./ContractsAddendumsRecord.vue?vue&type=script&lang=js"
import style0 from "./ContractsAddendumsRecord.vue?vue&type=style&index=0&id=2acbb019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbb019",
  null
  
)

export default component.exports